import MaterialTable, { MTableToolbar } from '@material-table/core';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import { createTheme, StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import MUICustomTheme from '../customTheme';
import appTheme from '../customTheme';

// Extend the app theme so primary stays consistent inside the table.
// Override secondary fully (main + light + dark) so the selection toolbar
// and checkboxes use blue instead of the default pink.
// The toolbar highlight uses: lighten(secondary.light, 0.85) for background
// and secondary.main for text color — so both must be blue.
const materialTableTheme = createTheme(appTheme, {
  palette: {
    secondary: appTheme.palette.augmentColor({
      color: { main: appTheme.palette.primary.main }
    })
  }
});

const cellStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: 150
};

// Wrap icons with forwardRef to support refs
const SearchIconWithRef = React.forwardRef(function SearchIconWithRef(props, ref) {
  return <SearchIcon color="primary" ref={ref} {...props} />;
});
const AddIconWithRef = React.forwardRef(function AddIconWithRef(props, ref) {
  return <AddIcon color="gray" ref={ref} {...props} />;
});

// Custom toolbar that forces blue highlight instead of pink when rows are selected
const BlueMTableToolbar = React.forwardRef(function BlueMTableToolbar(props, ref) {
  return (
    <ThemeProvider theme={materialTableTheme}>
      <MTableToolbar {...props} ref={ref} />
    </ThemeProvider>
  );
});

export const FoMaterialTable = (props) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={materialTableTheme}>
      <MaterialTable
        {...props}
        options={{
          ...props.options,
          addRowPosition: 'first',
          headerStyle: props?.options?.headerStyle ? props.options.headerStyle : { textTransform: 'uppercase' }
        }}
        columns={props.columns.map((column) => ({
          ...column,
          cellStyle: { ...cellStyle, ...column.cellStyle }
        }))}
        components={{
          ...props.components,
          Toolbar: props.components?.Toolbar ? props.components.Toolbar : (toolbarProps) => <BlueMTableToolbar {...toolbarProps} />
        }}
        icons={{
          Search: SearchIconWithRef,
          Add: AddIconWithRef
        }}
      />
    </ThemeProvider>
  </StyledEngineProvider>
);
